module.exports = __webpack_public_path__ + "static/img/arrow.1a46be8b.png";